const GemIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M6 3h12l4 6-10 12L2 9z" fill="#7fd3e8" stroke="#4a3524" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M2 9h20M9 3 7 9l5 12M15 3l2 6-5 12" fill="none" stroke="#4a3524" strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
  </svg>
);

export default GemIcon;